import React from 'react';
import { useAppContext } from '../AppContext';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';

const NotificationToast = () => {

  const { showToast, toastContent, closeToast } = useAppContext();

  if (!showToast) {
    return null;
  }

  return (
    <div aria-live="polite" aria-atomic="true" className="position-fixed top-0 right-0" style={{zIndex: "100000000"}}>
      <div className="toast-container">
        <Toast isOpen={showToast} className="m-3">
          <ToastHeader tagClassName="d-flex align-items-center w-100">
              <div className={`icon icon-shape rounded-circle shadow p-1 mr-2 ${toastContent.color}`} style={{height: "auto", width: "auto"}}>
                <i className={`ni ni-${toastContent.icon} text-white`}  />
              </div>
              <div className="flex-grow-1">
                {toastContent.title}
              </div>
              <button type="button" className="ml-2 my-0 close" onClick={closeToast}>
                <span aria-hidden="true">×</span>
              </button>
          </ToastHeader>
          <ToastBody>
            {toastContent.message}
          </ToastBody>
        </Toast>
      </div>
    </div>
  );
};

export default NotificationToast;